import { css } from '@emotion/css/macro';
import Color from '../../../../common/Color';
import StyleConstants from '../../../../common/StyleConstants';

export default function HelpView() {
  const style = css`
    max-width: ${StyleConstants.MAX_WIDTH}px;
    width: 100%;
    background-color: #4855d1;
    padding: 50px 0;
    h1 {
      font-size: 22px;
      color: ${Color.WHITE};
      letter-spacing: -0.82px;
      line-height: 1.45;
      text-align: center;
      b {
        font-weight: bold;
      }
    }
    img {
      display: block;
      width: 100px;
      left: 0;
      right: 0;
      margin: 17px auto 0;
    }
  `;
  return (
    <section className={style}>
      <h1>
        문제행동으로 인한 괴로움없이
        <br />
        <b>강아지와 평생 행복</b>할 수 있도록
        <br />
        <b>도깃이 도와드릴게요</b>
      </h1>
      <img src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-help.png' />
    </section>
  );
}
